import { render, staticRenderFns } from "./RelationshipCurrentlyYN.vue?vue&type=template&id=60d67ffe"
import script from "./RelationshipCurrentlyYN.vue?vue&type=script&lang=js"
export * from "./RelationshipCurrentlyYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports